import React, {useState, useEffect} from "react";
import { GetStoresData, GetUsersData} from "../../../lib/data";
import AddNotificationsUi from "../../../ui/notificationsUi/addNotifications";
import { useTranslation } from "react-i18next";

export default function AddNotifications () {

    const [usersData, setUsersData] = useState([]);
    const [storeData, setStoreData] = useState([]);
    const { i18n } = useTranslation();
    const t = i18n.t.bind(i18n); 
    
    useEffect(() => {
        handleApi();
    }, [])

    const handleApi = async () => {
        const userData = await GetUsersData();
        const storeData = await GetStoresData();
        setUsersData([]);
        setStoreData([]);
        userData.data.map((e) => setUsersData((prev) => [...prev, e]));
        storeData.data.map((e) => setStoreData((prev) => [...prev, e]));
    };

    const searchUser = async (param) => {
        const params = [ {"name": param} ];
        if(param){
            const usersDataFilter = await GetUsersData(1,params);
            setUsersData([]);
            usersDataFilter.data.map((e) => setUsersData((prev) => [...prev, e]));
        }
    };

    const searchStore = async (param) => {
        const params = [ {"name": param} ];
        if(param){
            const storeDataFilter = await GetStoresData(1,params);
            setStoreData([]);
            storeDataFilter.data.map((e) => setStoreData((prev) => [...prev, e]));
        }
    };

    return(
        <div className="p-5 my-3 mx-6 rounded-lg bg-thirdly">
            <div>
                <h1 className="sm:text-[30px] text-[24px] text-center text-gray pt-1 sm:pb-8 pb-4">{t("add_page_title.notification")}</h1>
                <AddNotificationsUi searchUser={searchUser} searchStore={searchStore} usersData={usersData} storeData={storeData} />
            </div>
        </div>
    );
};